import React from 'react';

const MarketPanel52WeekHighLow = ({ data }) => {
  return (
    <div className="row">
      <div className="panel panel-default with-rounded-corner with-shadow p-10 w-100">
        <div className="panel-heading border-0">
          <span className="panel-title">52 Week High Low</span>
        </div>
        <div className="panel-body">
          <table className="table table-condensed table-bordered bg-white" id="52-week-high-low">
            <thead>
              <tr>
                <th>Stock Name</th>
                <th>Current Price</th>
                <th>52W High</th>
                <th>52W Low</th>
                <th>% from High</th>
                <th>% from Low</th>
                <th>Volume</th>
                <th>Market Cap (₹ Cr)</th>
                <th>P/E Ratio</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.stock_name || '-'}</td>
                    <td>{item.current_price || '-'}</td>
                    <td>{item.week52_high || '-'}</td>
                    <td>{item.week52_low || '-'}</td>
                    <td>{item.percent_from_high || '-'}</td>
                    <td>{item.percent_from_low || '-'}</td>
                    <td>{item.volume || '-'}</td>
                    <td>{item.market_cap || '-'}</td>
                    <td>{item.pe_ratio || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MarketPanel52WeekHighLow; 